import React, { useEffect, useState } from 'react';

function SlowApiNotification() {
    const [isSlow, setIsSlow] = useState(false);

    useEffect(() => {
        const handleSlow = () => setIsSlow(true);
        const handleReady = () => setIsSlow(false);

        window.addEventListener('api-slow', handleSlow);
        window.addEventListener('api-ready', handleReady);

        return () => {
            window.removeEventListener('api-slow', handleSlow);
            window.removeEventListener('api-ready', handleReady);
        };
    }, []);

    if (!isSlow) return null;

    return (
        <div style={styles.banner}>
            <div style={styles.spinner}></div>
            <span>Waking up server... first request may take 30-60 seconds</span>
        </div>
    );
}

const styles = {
    banner: {
        position: 'fixed',
        top: '24px',
        left: '50%',
        transform: 'translateX(-50%)',
        background: 'var(--bg-elevated)',
        color: 'var(--text)',
        padding: '12px 24px',
        borderRadius: 'var(--radius-full)',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        zIndex: 9999,
        border: '1px solid var(--border)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.6)',
        fontSize: '13px',
        fontWeight: '500',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        animation: 'fadeIn 0.3s ease-out'
    },
    spinner: {
        width: '14px',
        height: '14px',
        border: '2px solid var(--border)',
        borderTop: '2px solid var(--accent)',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
    }
};

export default SlowApiNotification;